import styled, { css } from 'styled-components'
import { themeStyles } from '../../../styles/theme'
import TimesWhiteIcon from '../../../images/icon_times_white.svg'
import { StyledDrawerCloseButton } from '../../atoms/drawer/styles'

export const StyledWithdrawForm = styled.form`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  min-height: ${({ isMobile, navbarHeight }) =>
    isMobile ? `calc(100svh - ${navbarHeight}px)` : '100%'};

  padding: ${({ isMobile }) =>
    isMobile ? '22px 26px 1rem 26px' : '20px 26px 2rem 26px'};

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    text-align: left;
  }

  .btn-cta {
    margin-top: ${({ expand }) => expand && 'auto'};
  }
`

export const customHeaderStyles = css`
  background: ${themeStyles.colors.black.main};
  color: ${themeStyles.colors.white.main};

  ${StyledDrawerCloseButton} {
    background-image: url('${TimesWhiteIcon}');
    top: 50%;
    right: 18px;
  }
`

export const StyledDrawerWrapper = styled.div`
  z-index: 489;
  position: relative;

  ${({ isMobile }) =>
    isMobile &&
    css`
      z-index: 9999;
    `}
`

export const StyledAccountDetails = styled.div`
  display: grid;
  gap: 28px;
  border-block: 1px solid ${themeStyles.colors.lightGreys[1].main};
  padding-block: 28px;
  margin-top: 40px;
`

export const StyledWithdrawAmount = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const StyledWithdrawAmountValue = styled.span`
  font-weight: 700;
  font-size: 3.125rem;
  line-height: 1.3;
  color: #000000;
`

export const StyledToAccount = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 8px;

  p {
    margin: 0;
  }
`

export const StyledAmountChange = styled.button`
  display: flex;
  align-items: center;
  background: transparent;
  border: none;
  cursor: pointer;

  img {
    margin-right: 5px;
  }

  span {
    font-weight: 400;
    font-size: 15px;
    color: #3c3c3c;
  }
`

export const StyledAccountDetailLine = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  span:first-of-type {
    font-weight: 600;
  }
`
